class SliderDraggableEvent {

	// commands

	get PREV() { return 'prev'; }
	get NEXT() { return 'next'; }
	get SEEK() { return 'seek'; }

	// state changes

	get DRAG_START() { return 'drag-start'; }
	get DRAG_END() { return 'drag-end'; }
	get SEEKING() { return 'seeking'; }

}

export default new SliderDraggableEvent();
